export var SEARCH_EMPTY_SUGGESTIONS_LIST_CLASS_PREFIX = 'SearchEmptySuggestionsList';